import * as React from 'react';
import { ComponentWithInnerHTML } from '@cian/frontend-e2e-deal-component';
import { whiteList } from 'xss';
import { useMemo } from 'react';

import { sanitizeLink } from '../sanitizeLink';
import { useApplicationContext } from '../applicationContext';
import { ERuntimeSettings } from '../../types/runtimeSettings';

export interface IQrContactCard {
  href: string;
  title: string;
  qrCodeSrc: string;
  description: string;
}
export interface IRawFooterData {
  email: string;
  phone: string;
  phoneDescription: string;
  qrContactCards: IQrContactCard[];
}

const defaultData: IRawFooterData = {
  email: '',
  phone: '',
  phoneDescription: '',
  qrContactCards: [],
};

export const useCommonFooterData = () => {
  const { config } = useApplicationContext();
  const data = config.get<IRawFooterData>(ERuntimeSettings.E2eDealSaleCommonFooterData) || defaultData;

  return useMemo(() => {
    const extendedWhiteList = {
      ...whiteList,
      a: ['href', 'data-testid'],
    };

    return {
      ...data,
      prepareQrData: data.qrContactCards.map((qrData: IQrContactCard) => ({
        ...qrData,
        description: (
          <ComponentWithInnerHTML
            setHtmlOptions={{
              whiteList: extendedWhiteList,
              onTagAttr: sanitizeLink,
            }}
            html={qrData.description}
          />
        ),
      })),
    };
  }, []);
};
